//@flow
import { commitMutation, graphql } from 'react-relay';
import type { PayloadError } from 'react-relay';

const mutation = graphql`
    mutation profileAwardsMutation($input: FirmDesignProfileAwardsMutationInput!) {
        firmDesignProfileAwardsMutation(input: $input) {
            tradeFirm {
                publicProfile {
                    awards {
                        serviceId
                        name
                        status
                    }
                }
            }
        }
    }
`;

type Args = {|
    firmId: string,
    awardIds: Array<?string>,
|};

export const profileAwardsMutation = (environment: Object, args: Args): Promise<void> => {
    const { firmId, awardIds } = args;
    const input = {
        serviceId: firmId,
        awardIds,
    };

    return new Promise((resolve, reject) => {
        const onCompleted = (response, errors: ?Array<PayloadError>) => {
            if (errors && errors.length) {
                reject(errors);
            }
            resolve(response);
        };

        const onError = (error: Error) => {
            reject([error]);
        };

        try {
            commitMutation(environment, {
                mutation,
                variables: { input },
                onCompleted,
                onError,
            });
        } catch (error) {
            reject([error]);
        }
    });
};
